import { StyleSheet, Text, View, ViewProps } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";

const TesterBadge: React.FC<ViewProps> = ({ style, ...rest }) => {
  return (
    <View style={[styles.testerBadge, style]} {...rest}>
      <Text style={styles.badgeTesterLabel}>TESTER</Text>
    </View>
  );
};

export default TesterBadge;

const styles = StyleSheet.create({
  badgeTesterLabel: {
    ...kFonts.poppinsLight,
    alignSelf: "center",
    color: kColors.white,
    fontSize: 10,
    fontWeight: "400",
    letterSpacing: kStyleConst.kSlightLetterSpacing,
  },
  testerBadge: {
    alignItems: "center",
    alignSelf: "flex-start",
    backgroundColor: kColors.gray400,
    borderRadius: kStyleConst.kTesterBadgeHeight / 2,
    flexDirection: "row",
    height: kStyleConst.kTesterBadgeHeight,
    justifyContent: "center",
    paddingHorizontal: kStyleConst.kSpacing * 2,
  },
});
